import "./SidemenuPage.css";
import React, { useEffect } from "react";
import { ListGroup } from "react-bootstrap";
import dashboard from "./../../../../assets/dashboard.svg";
import { NavLink, useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import bellicon from "./../../../../assets/bellicon.svg";
import shopbag from "./../../../../assets/shop-bag.svg";
import wishlist from "./../../../../assets/wishlist.svg";
import like from "./../../../../assets/like.svg";
import setting from "./../../../../assets/setting.svg";
import profile_default from "./../../../../assets/profile_default.png";
import { useTranslation } from "react-i18next";
import { updateNotifictioncount } from "../../dashboard/redux/actions";
import chat_icon from "../../../../assets/chat_icon.svg";
import { storeChathistory } from "../../../header/redux/actions";
import pencil_outline from "../../../../assets/pencil_outline.svg";
import store_outline from "../../../../assets/store_outline.svg";
import myrides_icon from "../../../../assets/myrides_icon.svg";
import { getRequestcall } from "../../../comman/util/getRequest";
import {
  MY_CHAT_LIST,
  NOTIFICATIONCOUNT_UPDATE,
} from "../../../constants/apiurl";
import { postRequestcall } from "../../../comman/util/postRequest";
import { setStoreMessageReceived } from "../../../chat/redux/actions";

function SidemenuPage(props) {
  
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const data = [
    {
      text: t("pages.sidenav.dashboard"),
      link: "/user/dashboard",
      image:dashboard
    },
    {
      text: t("pages.sidenav.myorders"),
      link: "/user/myorders",
      count: props.new_orders,
      image: shopbag
    },
    {
      text: t("pages.sidenav.myrides"),
      link: "/user/my-rides",
      image: myrides_icon
    },
    {
      text: t("pages.sidenav.wishlist"),
      link: "/user/wishlist",
      image: wishlist
    },
    {
      text: t("pages.sidenav.myreviews"),
      link: "/user/review",
      image: like
    },
    {
      text: t("pages.header.chat"),
      link: "",
      type: "chat",
      image:chat_icon
    },
    {
      text: t("pages.sidenav.notifications"),
      link: "/user/notifications",
      count: props.notificationcount,
      image:bellicon
    },
    {
      text: t("pages.sidenav.setting"),
      link: "/user/settings",
      image: setting,
    },
  ];

  // eslint-disable-next-line
  useEffect(() => {
    (async () => callNotificationupdate())();
    // eslint-disable-next-line
  }, []);

  const callNotificationupdate = async () => {
    let getNotificationupdateresponse = await getRequestcall(
      NOTIFICATIONCOUNT_UPDATE,
      props?.access_token
    );
    if (getNotificationupdateresponse?.status === 200) {
      let getValue = await getNotificationupdateresponse.json();
      props.updateNotifictioncount(getValue?.data.notification_count);
    } else if (getNotificationupdateresponse.status === 401) {
      navigate("/", { state: { autologout: true } });
    }
  };

  const gotoChat = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    dispatch(setStoreMessageReceived({messages:[], users_id:""}))
    let getList = await postRequestcall(MY_CHAT_LIST, props?.access_token);
    if (getList?.status === 200) {
      let getres = await getList.json();
      if (getres?.data?.chat_list?.length > 0) {
        navigate(`/chat/${getres?.data?.chat_list[0].user_detail?.jid}`);
      }
    } else {
      navigate(`/chat/no-chat`);
    }
  };

  const openPage = async () => {
    props.setShowsidenav(false);
  };

  return (
    <div
      className={`left-menu col-xl-3 ${
        props.showSidenav ? "left_menu_visible" : ""
      }`}
    >
      <div className="card sidenav radius-20">
        <div className="card-body">
          {props.showSidenav && (
            <button
              onClick={() => openPage()}
              className={"chevron-left btn-black"}
            >
            <i className="mask_icon close_icon white" />
            </button>
          )}
          <div className="side_profile">
            <div className="badge_div me-2">
              <img
                alt="profile_pic"
                src={
                  props?.logindata?.image_url === null
                    ? profile_default
                    : props?.logindata?.image_url
                }
                onError={(e) => {
                  e.target.src = profile_default;
                }}
                className={"profile_pic "}
              />
              <span
                className="badge"
                onClick={() => navigate("/user/settings")}
              >
                <img
                  src={pencil_outline}
                  className="pencil-outline"
                  alt="edit"
                ></img>
              </span>
            </div>
            <div>
              <h5 className="profile_title m-0">
                {props?.logindata?.first_name}
              </h5>
              <p className="profile_email se-color m-0 ">
                {props?.logindata?.email}
              </p>
            </div>
          </div>
          <ListGroup className="catelist">
            {data.map((item, index) =>
              index === 5 ? (
                <ListGroup.Item
                  action
                  className="chat-item"
                  onClick={(e) => gotoChat(e)}
                  key={index?.toString()}
                >
                  <i className="mask_icon" style={{WebkitMaskImage:`url('${item?.image}')`, maskImage:`url('${item?.image}')`}} />
                  <label>{item.text}</label>
                </ListGroup.Item>
              ) : (
                <NavLink
                  key={index.toString()}
                  className={"navlink "}
                  to={item?.link}
                >
                  <ListGroup.Item
                    action
                    className=""
                    onClick={() => openPage()}
                  >
                    <i className="mask_icon" style={{WebkitMaskImage:`url('${item?.image}')`, maskImage:`url('${item?.image}')`}} />
                    <label>{item.text}</label>
                    {item.count && item.count !== 0 ? (
                      <span className="badge">{item.count}</span>
                    ) : null}
                  </ListGroup.Item>
                </NavLink>
              )
            )}
            {props.type === "vendor" && (
              <NavLink
                className={"navlink vendorDashboard_button active mt-1"}
                to={"/vendor/dashboard"}
              >
                <div className="butttons">
                  <i className="mask_icon white_bg" style={{WebkitMaskImage:`url('${store_outline}')`, maskImage:`url('${store_outline}')`}} />
                  <label>{t("pages.View vendor panel")}</label>
                </div>
              </NavLink>
            )}
          </ListGroup>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  logindata: state?.login?.logindata,
  userdashboard: state?.userdashboard?.userdashboard,
  notificationcount: state?.userdashboard?.notificationcount,
  new_orders: state?.userdashboard?.new_orders,
  type: state?.login?.type,
});

export default connect(mapStateToProps, {
  updateNotifictioncount,
  storeChathistory,
})(SidemenuPage);
